import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ChatButton({ vehicle }) {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Hide button only for the seller themselves — everyone else (including guests) sees it
  const sellerId = vehicle?.seller_id;
  const userId   = user?.id;
  if (sellerId && userId && sellerId === userId) return null;

  // Label: "Chat with <Seller Name>" or fallback
  const sellerName = vehicle?.seller_name || 'Seller';
  const label      = `Chat with ${sellerName}`;

  const handleChat = async () => {
    // Not logged in → send to login first
    if (!user) {
      toast.info('Please login to chat with the seller');
      navigate('/login');
      return;
    }

    if (loading) return;
    setLoading(true);
    try {
      await axios.post(
        `${API}/conversations`,
        { vehicle_id: vehicle.id, seller_id: vehicle.seller_id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Chat started! Tap the chat bubble to open.');
      window.dispatchEvent(new CustomEvent('open-chat'));
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to start chat');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleChat}
      disabled={loading}
      className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white rounded-xl text-sm font-semibold transition disabled:opacity-60 touch-manipulation select-none"
    >
      {loading
        ? <Loader2 className="h-4 w-4 flex-shrink-0 animate-spin" />
        : <MessageCircle className="h-4 w-4 flex-shrink-0" />
      }
      <span>{label}</span>
    </button>
  );
}